import type { DateRange } from '../../components/social-media/types'

const DAY_MS = 24 * 60 * 60 * 1000

/**
 * The UTC calendar day before `now`'s UTC day, as YYYY-MM-DD.
 *
 * UTC, never the browser's zone: the server reads a To date as
 * `source_date < To + 1 day` on UTC timestamps, and the reconciliation page
 * counts UTC days, so a London evening and a London morning must name the same
 * day the server and that page do.
 */
export function yesterdayUtc(now: Date): string {
  const startOfToday = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  return new Date(startOfToday - DAY_MS).toISOString().slice(0, 10)
}

/**
 * What the Sky dashboards' Published and Comment date filters open on, and what
 * Clear All returns them to: no From, and a To of yesterday, i.e. everything up
 * to 23:59:59 UTC yesterday (Kai, 20 Oct 2026). The Sprinklr import runs at
 * 00:05 UTC, so yesterday is the last whole day held; today's partial day would
 * otherwise make every number move under the reader through the day.
 */
export function defaultSkyDateRange(now: Date): DateRange {
  return { to: yesterdayUtc(now) }
}

export { isSameDateRange } from '../../components/social-media/entityQuery'
